import{z}from'zod';var tombstoneSchema=z.object({reason:z.enum(['deleted'])});export{tombstoneSchema};